import { useState, useEffect } from "react";
import { useLiferayLanguage } from "../hooks/useLiferayLanguage";

export const Retribucion = ({ retribucion, index, showFirstOpen }) => {

    const accoridonAriaLabel = useLiferayLanguage("aena.label.expand.collapse.accordion", "Expandir/contraer accordeón");
    const detailsText = useLiferayLanguage("details", "Detalles");

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      setIsOpen(showFirstOpen && index === 0);
    }, [showFirstOpen, index]);

    const getMappedRetribucion = (retribucion) => {
      const mappedRetribucion = {};

      if (retribucion.taxonomyCategoryBriefs?.length) {
        mappedRetribucion.anio = retribucion.taxonomyCategoryBriefs[0].taxonomyCategoryName;
      }

      retribucion.contentFields?.forEach((contentField) => {
        if (contentField.name === "contenido") {
          mappedRetribucion.contenido = contentField.contentFieldValue?.data?.trim() || "";
        }
      });

      return mappedRetribucion;
    };

    const mapped = getMappedRetribucion(retribucion);

    return (
        <li
          className={`aena-accordion__item ${isOpen ? "is-open" : ""}`}
          id={`retribucion_${retribucion.id}_heading`}
        >
            <>
            <div className="aena-accordion__header">
                <div className="aena-accordion__header-text">
                    <h4>{mapped.anio}</h4>
                </div>

                <div className="aena-accordion__action">
                    <button
                        onClick={() => setIsOpen((prev) => !prev)}
                        aria-expanded={showFirstOpen && index === 0 ? "true" : "false"}
                        aria-controls={`acc-content-${retribucion.id}`}
                        id={`acc-item-${retribucion.id}`}
                        className="acc-trigger aena-accordion__button aena-button-icon-only aena-button-icon-only--small aena-button-icon-only--alternative"
                        type="button"
                        aria-label={`${accoridonAriaLabel} ${retribucion.id}`}
                    >
                        <svg className="aena-sprite" aria-hidden="true" focusable="false">
                            <use href="/o/aena-theme-spritemap/spritemap.svg#digital-flecha-abajo-1"></use>
                        </svg>
                    </button>

                    <span className="aena-accordion__action-label paragraph-semibold-large">{detailsText}</span>
                </div>
            </div>

            <div
                id={`acc-content-${retribucion.id}`}
                aria-labelledby={`acc-item-${retribucion.id}`}
                role="region"
                className={`aena-accordion__panel ${isOpen ? "is-open" : ""}`}
            >
                <div className="aena-accordion__content aena-accordion__content--no-gap">
                    {mapped.contenido && (
                        <div dangerouslySetInnerHTML={{ __html: mapped.contenido }} />
                    )}
                </div>
            </div>
            </>
        </li>
    );
};